module.exports = __webpack_public_path__ + "img/dingle-donation.3eb391b1.webp";